<div class="container-fluid footer-jpl" style='box-shadow:none;'>
    <div class="row text-center">
        <div class="col">
            Last Update: {{formatBuildTime()}} - Version: {{build.version}}
            <br>
            If you encounter any issues, please advise the JPL Submitter or Requestor identified in the JPL-ID invite email for assistance.
            <br />
            JPL is a federally funded research and development center staffed and managed for <a
            href="http://www.nasa.gov"
            target="_blank">NASA</a> by <a style='color: #A5A6A7;' href="http://www.caltech.edu" target="_blank">Caltech</a>
            <br>CL#: URS318173
            <br>
        </div>
    </div>
    <div class='space-taker'>
    </div>
</div>
